import React from "react";
import ResultDetailsTable from "./ResultDetails.jsx";
import {FormattedMessage} from "react-intl";

const QualificationResults = (props) => {
    if (!props.details) return null;

    return <div>
        <h3 className="result__title"><FormattedMessage id="rankings.qualifications"/></h3>
        <ResultDetailsTable {...props}/>
    </div>;
};

export default QualificationResults;
